export default () => ({
  show: false,
  message: null,
  type: 'success', // TODO
  timeout: 3000
})
